import { t } from "i18next";
import React, { useEffect } from "react";
import { useFetch } from "../../../../hooks/useFetch";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from "../../../../ui/AlertDialog/AlertDialog";
import { Button } from "@/ui/Button";

type Props = {
  maintenanceId: string;
  equipmentId: string;
  isDeleteOpen: boolean;
  closeModal: Function;
  closeEdit: Function;
  updateList: Function;
};

const DeleteMaintenance = ({ maintenanceId, equipmentId, isDeleteOpen, closeEdit, closeModal, updateList }: Props) => {
  const [{ response: deleteResponse, isLoading: deleteIsLoading, error: deleteError }, doFetchItemDelete] =
    useFetch(`/directories/equipment_items/${equipmentId}/maintenances/${maintenanceId}`);

  useEffect(() => {
    if (isDeleteOpen) {
      updateList();
      closeModal();
      closeEdit();
    }
  }, [deleteResponse]);

  const onDelete = () => {
    doFetchItemDelete({
      method: "DELETE",
    });
  };

  const openStateChange = () => {
    if (isDeleteOpen) closeModal();
  };

  return (
    <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
      <AlertDialogContent style={{ maxWidth: 450 }}>
        <AlertDialogTitle>Удалить эксплуатацию</AlertDialogTitle>
        <AlertDialogDescription>
          Вы уверены, что хотите удалить эксплуатацию?
        </AlertDialogDescription>
        <div className="flex justify-between mt-4">
          <Button
            variant={"destructive"}
            size={"md"}
            className="px-3"
            onClick={onDelete}
          >
            {t("delete")}
          </Button>
          <AlertDialogCancel className="h-8">{t("cancel")}</AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteMaintenance;
